import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { UseCampaignParams } from "./campaigns.types";
import { campaignQueryKeys } from "./queryKeys";

import { instance } from "@/lib/axios/instance";
import { CampaignType } from "@/types/response/CampaignType";

export function useCampaign({ campaignId, clientId }: UseCampaignParams) {
  return useQuery<CampaignType, AxiosError>({
    queryKey: campaignQueryKeys.detail(campaignId, clientId),
    queryFn: () =>
      instance
        .get<CampaignType>(`/api/v2/Campaigns/${campaignId}`, {
          params: {
            clientId,
          },
        })
        .then((res) => res.data),
    enabled: !!campaignId,
    refetchOnMount: true,
    refetchOnReconnect: false,
    staleTime: 2 * 60 * 1000,
  });
}
